export const brandTableHeader = [
  { key: "id", label: "id" },
  { key: "name", label: "name" },
  { key: "createdAt", label: "createdAt" },
  { key: "updatedAt", label: "updatedAt" },
];
